import { signedFetch } from './client';

export async function getLineage(storeName: string, eventId: string, direction: string = 'ancestors', maxDepth: number = 50) {
  const params = new URLSearchParams({ direction, maxDepth: String(maxDepth) });
  return signedFetch('GET', `/stores/${storeName}/lineage/${eventId}?${params.toString()}`);
}
